"use client";

import Script from "next/script";
import { useEffect, useState } from "react";
import { readConsent, CONSENT_EVENT } from "@/lib/consent";

// Hoofdmeting van de winkel.
const GA_ID = process.env.NEXT_PUBLIC_GA_ID;
// >>> MOW-SEO-OKT26 ga-lek
// De tweede stream G-177S7Q8J6Q (afkomstig uit de vreemde container GTM-MPHTW35, op 18-9-2026
// verwijderd) is op 4-10-2026 ook hier weggehaald: de audit stelde vast dat elke page_view, inclusief de
// /bedankt-URL met bestelnummer en toegangstoken, naar een property ging waarvan niet vaststaat dat
// die van ons is. Niet opnieuw toevoegen.
const GA_IDS = [GA_ID].filter(Boolean) as string[];

// Query-parameters die nooit naar Google Analytics mogen: /bedankt?order=<id>&t=<token> geeft met dat
// token toegang tot naam, e-mail en adres van de bestelling. utm_* en de rest blijven staan, want GA4
// leest de campagnebron uit page_location.
const GA_GEHEIME_PARAMS = ["order", "t", "token"];
// <<< MOW-SEO-OKT26 ga-lek

/**
 * Google Analytics 4.
 *
 * Gate't op de ANALYTICS-toestemming, niet op marketing. Dat is bewust en het
 * is sinds 18-9-2026 gewijzigd: de cookiebanner belooft de bezoeker al sinds
 * v2 "Analytisch — Google Analytics", maar in de praktijk hing GA4 aan de
 * marketing-vlag en deed het Analytisch-vinkje helemaal niets. Wie alleen
 * meting toestond, werd dus niet gemeten; wie alleen marketing toestond, werd
 * juist wél door GA4 gemeten zonder dat de banner dat zo beschreef.
 *
 * Advertentie- en remarketingtags horen NIET hier maar in GTM
 * (components/GoogleTagManager.tsx), dat op marketing blijft gate'n.
 *
 * Voorgeschiedenis: G-NQRP3XHSFY hoorde als "Google tag" ín GTM-M9M2CP7Z te
 * zitten, maar dat is nooit afgemaakt — live nagemeten op 17-9-2026 ontving dat
 * ID nul hits. Daarom laadt het hier weer rechtstreeks. Zet je het later tóch
 * in GTM, haal het dan hier weg, anders tel je page_view dubbel.
 */
export default function GoogleAnalytics() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const update = () => setAllowed(!!readConsent()?.analytics);
    update();
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, []);

  if (!GA_IDS.length || !allowed) return null;

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_IDS[0]}`} strategy="afterInteractive" />
      <Script id="ga4-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          var gaUrl = new URL(window.location.href);
          ${JSON.stringify(GA_GEHEIME_PARAMS)}.forEach(function (k) { gaUrl.searchParams.delete(k); });
${GA_IDS.map((id) => `          gtag('config', ${JSON.stringify(id)}, { page_location: gaUrl.toString() });`).join("\n")}
        `}
      </Script>
    </>
  );
}
